import api from '~/api'

const state = {
  categoriesTree: [],
}

const getters = {}

const mutations = {
  SET_CATEGORIES_TREE(state, payload) {
    state.categoriesTree = payload
  },
}

const actions = {
  async getCategoriesTree({ commit }) {
    const response = await api.get('category-trees?perPage=100')
    const [error, success] = response

    if (!error) {
      commit('SET_CATEGORIES_TREE', success.items)
    }
    return response
  },
  async createCategoryTree({ commit }, payload) {
    const response = await api.post('category-trees', payload)
    return response
  },
  async updateCategoryTree({ commit }, payload) {
    const response = await api.put(`category-trees/${payload.id}`, payload)
    return response
  },
  async deleteCategoryTree({ commit }, id) {
    const response = await api.delete(`category-trees/${id}`)
    return response
  },
  async getCategoryTree({ commit }, id) {
    const response = await api.get(`category-trees/${id}`)
    return response
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
